import { BehaviorSubject, Observable } from 'rxjs'

export class SuperSubject<T> {
  private subject: BehaviorSubject<T>

  observable$: Observable<T>

  get value(): T {
    return this.subject.value
  }

  set value(value: T) {
    this.subject.next(value)
  }

  constructor(value: T) {
    this.subject = new BehaviorSubject<T>(value)
    this.observable$ = this.subject.asObservable()
  }
}
